module.exports = __webpack_public_path__ + "a25ec3f696268e334e2e5dc9c498cb42.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/retribution.webm
// module id = 644
// module chunks = 0